module.exports = __webpack_public_path__ + "img/16.34782f3b.png";